import { createEvent } from "@cobuildlab/react-simple-state";
import { CardRequestsPagination } from "../../shared/types";

export const OnFetchCardRequests = createEvent<CardRequestsPagination>();
export const OnFetchCardRequestsError = createEvent();
